import { render, staticRenderFns } from "./MyButton.vue?vue&type=template&id=4317cccb&"
import script from "./MyButton.vue?vue&type=script&lang=js&"
export * from "./MyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports